import { render, staticRenderFns } from "./FrenchWindowDamageSeverity.vue?vue&type=template&id=864bf5e6&scoped=true"
import script from "./FrenchWindowDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864bf5e6",
  null
  
)

export default component.exports